<script>
import BaseMixinVue from '@/components/Feature/BaseMixin.vue';
import { hasProperty } from '@/common/Util/utility';

export default {
  mixins: [BaseMixinVue],
  data() {
    return {};
  },
  computed: {
    large() {
      return hasProperty(this, 'mediaQueries') ? this.mediaQueries.isLargeUp : true;
    },
    medium() {
      return hasProperty(this, 'mediaQueries') ? this.mediaQueries.isMediumOnly : false;
    },
    small() {
      return hasProperty(this, 'mediaQueries') ? this.mediaQueries.isSmallOnly : false;
    },
    isMobileMenuShown() {
      return this.$store.state.header.showMobileMenu;
    },
    isExperienceEditor() {
      return this.$store.state.general.isExperienceEditor;
    },
    isMegaMenuShown() {
      return this.$store.getters['header/showMegaMenu'];
    },
    megaMenuPage() {
      return this.$store.state.header.megaMenuPage;
    },
    isSearchBareShown() {
      return this.$store.state.header.showMobileMenu;
    },
    isScrolled() {
      return this.$store.state.header.isScrolled;
    },
    websiteType() {
      var domain = window.location.hostname;
      var type = domain.indexOf('minside') !== -1 ? 'min side' : 'open page';
      return type;
    }
  },
  methods: {
    linkEditorFieldIfPossible(linkObject) {
      return linkObject.EditorField ? linkObject.EditorField : linkObject.Text;
    }
  }
};
</script>
